module.exports = __webpack_public_path__ + "img/smile.30a897d0.svg";